import { useCallback } from 'react'
import { useMutate } from 'restful-react'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import { useNotifications } from '@trileuco/triskel-react-ui/components/ui/notifications'
import { useErrorNotification } from 'modules/bookables/notifications'

const useMakeAdmin = (options) => {
  const { mutate, ...rest } = useMutate({
    path: `/auth/make-admin/`,
    verb: 'POST',
    ...options
  })
  const { notifyError } = useErrorNotification()
  const {
    notify,
    statusTypes: { LOADING, SUCCESS }
  } = useNotifications()

  const { msg } = useIntl({
    scope: 'balaena.api.useMakeAdmin',
    ignoreGlobalScope: true
  })
  const notifyMakeAdmin = useCallback(
    (notification) => {
      notify({
        id: 'MAKE-ADMIN',
        title: msg({ id: notification.status }),
        ...notification
      })
    },
    [notify, msg]
  )
  const makeAdmin = useCallback(
    (params) => {
      notifyMakeAdmin({ status: LOADING })
      return mutate(params)
        .then((response) => {
          notifyMakeAdmin({ status: SUCCESS })
          return response
        })
        .catch((error) => {
          notifyError({
            id: 'MAKE-ADMIN',
            title: msg({ id: 'error' }),
            error
          })
          throw error
        })
    },
    [notifyMakeAdmin, LOADING, mutate, SUCCESS, notifyError, msg]
  )
  return {
    makeAdmin,
    ...rest
  }
}

export default useMakeAdmin
